// 「帮助 & 反馈」入口配置（组件本体 help-feedback.ts vendored 自 _shared/）。
import { mountHelpFeedback } from './help-feedback';

const GROUP_LINK =
  'https://applink.feishu.cn/client/chat/chatter/add_by_link?link_token=3c6o4088-552f-4186-9151-ec003ffbbffa';

const GROUP_QR = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWgAAAFoAQMAAABAK/OWAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP//8i138cAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAH2SURBVHic7dTBcgIxDANQ/f9Pu1Ms2YG2BxpdmNHCwG7ynMM6CuqdC9HRn6bR1/c9sCvgMdc3K6Lv9b54zhbvZ5ER0Q4NzlXfLQJHKaKtuhiNGod6EtFWrRYV1KhSRqKdeg93XkoGZ/HLWRX9by3x94ci2qF14ejCz1lNRd9qvv3SydNl0PGj4miTrh7fwj7bZzFmBdFOjSnCOaEFeiDaoLnruf9VwGT0DxMS7dFqyTRnaottOwITfa256UlemgVwFNEWXTVN2aphzAFVtEFjCtQfpoPx2Jpoh27Tmk/zDz3zJ9qg+f6LnJ1RGpSLaJOejT9lGtPTrBN9rzGtwez7p1bxAdFGfe75/WepiqMtuhQCFrFP0w5wzWiLZhBKBR0DTZzZiHboaRJomYauVpeiTfrxd0YC0yVwnhmJdmjszhcbd4Ql2qWhHxVvJtg5xiLaobXfe/xV6I4q+lr3ME+bqcd2TSDapAdMfwj3jrXRDs1dXwrD8yqbkWiPnqNH80wGlIqzNdHXuqenUzzicSyj2+h7rUs5wN6qc8pJtEFjjheCPoxKPdqaaIvWidMfHTxT393Z4ETfanaAO34apJS8nFXRLn3OntOF43CK9mk1hjE4uqbIRBt07cvfMHBUn+1O9KXm6+9vzVlzZGKLo6/1G1d09GfpL40enV13t/63AAAAAElFTkSuQmCC';

/** 底部常驻栏也要用的群链接。 */
export { GROUP_LINK };

let mounted = false;
let openFn: (() => void) | null = null;

export function initHelpFeedback(): void {
  if (mounted) return;
  // 触发按钮挂进一个不上树的容器 = 不显示浮动圆钮。
  // 入口改为 App 底部常驻栏（openHelp），首开自动引导保留。
  const hiddenHost = document.createElement('div');
  const { open } = mountHelpFeedback({
    pluginName: '排版打印',
    quickStart: [
    '选中要打印的记录（可多选）',
    '挑一个打印模板，字段自动排版',
    '预览无误后一键打印 / 导出 PDF'
    ],
    groupLink: GROUP_LINK,
    qrDataUri: GROUP_QR,
    mountInto: hiddenHost,
    compact: true,
    autoOpenFirstRun: true
  });
  openFn = open;
  mounted = true;
}

/** 打开「帮助 & 反馈」面板（底部常驻栏的「快速上手」入口用）。 */
export function openHelp(): void {
  initHelpFeedback();
  openFn?.();
}
